import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterAbmelden() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/newsletter/unsubscribe/${token}`);
        setEmail(res.data?.email || "");
        setStatus("ok");
      } catch {
        setStatus("error");
      }
    })();
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center px-6">
      <div className="max-w-lg w-full bg-white border border-[#E3DECE] p-8 md:p-12 text-center" data-testid="newsletter-unsubscribe-page">
        {status === "loading" && (
          <>
            <Loader2 size={40} className="mx-auto animate-spin text-[#BA6D52]" />
            <p className="mt-6 text-sm text-[#757067]">Abmeldung wird verarbeitet …</p>
          </>
        )}
        {status === "ok" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-emerald-600" />
            <h1 className="font-serif text-3xl md:text-4xl font-light tracking-tighter mt-6 text-[#2C2A26]">
              Abgemeldet
            </h1>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              <b>{email}</b> wurde vom Newsletter abgemeldet. Sie erhalten keine weiteren Werbe-Nachrichten. Wichtige geschäftliche E-Mails zu bestehenden Aufträgen (Bestätigungen, Rechnungen) werden davon nicht berührt.
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle size={56} className="mx-auto text-red-500" />
            <h1 className="font-serif text-3xl md:text-4xl font-light tracking-tighter mt-6 text-[#2C2A26]">
              Link ungültig
            </h1>
            <p className="mt-4 text-[#757067] font-light leading-relaxed">
              Dieser Abmelde-Link ist ungültig. Bitte kontaktieren Sie uns direkt unter <a href="mailto:mietkoch@stutz-cuisine.com" className="text-[#BA6D52] underline">mietkoch@stutz-cuisine.com</a>, wenn Sie sich abmelden möchten.
            </p>
          </>
        )}
        <Link
          to="/"
          data-testid="newsletter-back-home"
          className="mt-10 inline-block text-xs uppercase tracking-[0.25em] text-[#BA6D52] hover:text-[#9E5841] underline"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
